import { render, staticRenderFns } from "./QueenDelete.vue?vue&type=template&id=e683109a&scoped=true&"
import script from "./QueenDelete.vue?vue&type=script&lang=js&"
export * from "./QueenDelete.vue?vue&type=script&lang=js&"
import style0 from "./QueenDelete.vue?vue&type=style&index=0&id=e683109a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e683109a",
  null
  
)

export default component.exports